import { useQuery } from 'react-query';
import { adminAPI } from '../services/api';

export const useSystemStatus = () => {
  return useQuery('admin-system-status', adminAPI.getSystemStatus, {
    staleTime: 60 * 1000, // 1 minute
  });
};
